import ProjectCalendarPageComponent from '../components/ProjectCalendarPage';
import { getProjectCalendarSSP } from '../lib/getServerSideProps';

const ProjectCalendar = (props) => {
  return <ProjectCalendarPageComponent {...props} />;
};

export default ProjectCalendar;

export const getServerSideProps = getProjectCalendarSSP();
